import locationStops from './locationStops'

const api = {
  ...locationStops
}

export default api
